// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"266":"3b3926b8","1786":"7886ab9b","2404":"b9a4d82d","3760":"8cb3c356","4515":"b9a4d82d"}[chunkId] + ".chunk.css";
};